// extracted by mini-css-extract-plugin
export default {"bindCardWrapper":"BindCards_bindCardWrapper__ruHRz","bankCard":"BindCards_bankCard__gW+A1","bankDetails":"BindCards_bankDetails__t3p57","mainWrapper":"BindCards_mainWrapper__xzjmW"};